import { Component, Input, OnInit } from '@angular/core';
import { StationService } from 'src/app/_services/station.service';
import { TableBtn } from '../../../../shared/interfaces/table-btn';
import { TableColumn } from '../../../../shared/interfaces/table-column';
import * as _moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DeviceTransData, TransactionData } from './device-trans.model';
import { SnackbarService } from '../../../../_service/message-service';
import { ExportCSVService } from 'src/app/_services/export-csv.service';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { Permission } from 'src/app/util/enums/permission.enum';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { GeneralDialogComponent } from 'src/app/shared/components/general-dialog/general-dialog.component';
import { Subscription, timer } from 'rxjs';
import { take } from 'rxjs/operators';

declare var $: any;

@Component({
  selector: 'telio-device-trans',
  templateUrl: './device-trans.component.html',
  styleUrls: ['./device-trans.component.scss']
})
export class DeviceTransComponent implements OnInit {
  columns: TableColumn[];
  buttons: TableBtn[];
  data: DeviceTransData[];
  actionHeader: string = '';
  tcolumns: TableColumn[];
  tdata: TransactionData[]
  transactionTabs: string[] = ["30m", "60m", "Last 2hrs", "Last 4hrs", "Total hrs"];
  selectedIndex = 4;
  transactionID: any;
  startDate: Date;
  endDate: Date;
  selected: { start: _moment.Moment, end: _moment.Moment };
  @Input() stationId = '';
  showModal = false;
  selectedDate: any;
  datePickerSettings: any;
  datePickerOptions: any;
  transTips = [];
  filterPlaceholder: string = '';
  selectedTab: any;
  initialTransData: any;
  initialTransDetailData: any;
  filterClicked = false;
  intervalslist: any[] = [];
  pageList = {
    currentPage: 0,
    pageSize: 10
  };
  currentPage = 0;
  totalDataCount = 0;
  sortColumn = '';
  sortDirection = 'asc';
  tTotalDataCount = 0;
  @Input() routeID = null;
  actionFeatureLabel = '';
  actionFeatureFlag = false;
  subscription: Subscription = new Subscription;
  checkStatus = false;
  currentStatus;
  clock = 0;
  tick = 1000;
  countDown: Subscription;
  timeflag = false;
  stDate = '';
  edDate = '';
  isReloadDevice = false;

  constructor(readonly exportCSVService: ExportCSVService, readonly stationService: StationService,
    readonly translate: TranslateService, readonly toasterService: SnackbarService, private authenticationService: AuthenticationService,
    readonly userInfoService: UserInfoService, readonly route: ActivatedRoute, public dialog: MatDialog) {
    this.filterPlaceholder = 'generalTable.filterPlaceholder';

    this.transTips.push('stationDetail.deviceTransaction.infoTips.one');
    this.transTips.push('stationDetail.deviceTransaction.infoTips.two');
  }

  ngOnInit() {
    this.rerender(this.stDate, this.edDate, this.pageList, '');
    this.columns = [
      { columnDef: 'transactionId', header: 'stationDetail.deviceTransaction.transactionId', cell: (element: DeviceTransData) => `${element.transactionId}`, sortingDisabled: false, isLink: this.userInfoService.filterPermission(this.routeID, Permission.READ), width: '111px' },
      { columnDef: 'connectorId', header: 'stationDetail.deviceTransaction.connectorId', cell: (element: DeviceTransData) => `${element.connectorId}`, sortingDisabled: false, width: '100px' },
      { columnDef: 'userId', header: 'stationDetail.deviceTransaction.userId', cell: (element: DeviceTransData) => `${element.userId}`, sortingDisabled: false, width: '96px' },
      { columnDef: 'createdDate', header: 'stationDetail.deviceTransaction.createdDate', cell: (element: DeviceTransData) => `${element.createdDate}`, sortingDisabled: false, width: '131px' },
      { columnDef: 'stopDate', header: 'stationDetail.deviceTransaction.updatedDate', cell: (element: DeviceTransData) => `${element.stopDate}`, sortingDisabled: false, width: '131px' },
      { columnDef: 'chargingDuration', header: 'stationDetail.deviceTransaction.chargingDuration', cell: (element: DeviceTransData) => `${element.chargingDuration}`, sortingDisabled: true, align: 'right', headerAlign: true, width: '123px' },
      { columnDef: 'totalMeterValue', header: 'stationDetail.deviceTransaction.totalMeterValue', cell: (element: DeviceTransData) => `${element.totalMeterValue}`, sortingDisabled: false, align: 'right', headerAlign: true, width: '132px' },
      { columnDef: 'platform', header: 'mobileUsers.platform', cell: (element: DeviceTransData) => `${element.platform}`, sortingDisabled: false, width: '84px' },
      { columnDef: 'status', header: 'stationDetail.deviceTransaction.status', cell: (element: DeviceTransData) => `${element.status}`, sortingDisabled: false, caseSensitive: 'uppercase', width: '84px' }
    ];

    this.tcolumns = [
      { columnDef: 'timestamp', header: 'stationDetail.transactiondetails.transactionDate', cell: (element: TransactionData) => `${element.timestamp}`, sortingDisabled: false, width: '155px' },
      { columnDef: 'soc', header: 'stationDetail.transactiondetails.batterypercentage', cell: (element: TransactionData) => `${element.soc}`, sortingDisabled: true },
      { columnDef: 'powerOffered', header: 'stationDetail.transactiondetails.power', cell: (element: TransactionData) => `${element.powerOffered}`, sortingDisabled: true },
      { columnDef: 'currentImport', header: 'stationDetail.transactiondetails.currentImport', cell: (element: TransactionData) => `${element.currentImport}`, sortingDisabled: true },
      { columnDef: 'currentOffered', header: 'stationDetail.transactiondetails.currentOffered', cell: (element: TransactionData) => `${element.currentOffered}`, sortingDisabled: true },
      { columnDef: 'temperature', header: 'stationDetail.transactiondetails.temperature', cell: (element: TransactionData) => `${element.temperature}`, sortingDisabled: true },
      { columnDef: 'voltage', header: 'stationDetail.transactiondetails.voltage', cell: (element: TransactionData) => `${element.voltage}`, sortingDisabled: true },
      { columnDef: 'energyActiveImportRegister', header: 'stationDetail.transactiondetails.metervalue', cell: (element: TransactionData) => `${element.energyActiveImportRegister}`, sortingDisabled: true }
    ];
    this.actionFeatureLabel = 'stationDetail.deviceTransaction.forceStop';
  }

  applyFilter(filteredData: string) {
    this.rerender(this.stDate, this.edDate, this.pageList, filteredData)
  }

  applyFilterID(filteredData: string) {
    this.rerenderID(this.pageList, filteredData)
  }

  filterInterval(tab, i) {
    this.selectedIndex = i;
    this.filterClicked = true;
    let filterval = this.data.find(res => res.transactionId == this.transactionID);
    let startDate = filterval.createdDate;
    if (this.tdata.length > 0) {
      let endDate = this.tdata[0].timestamp;
      let init: any = new Date(startDate);
      let end: any = new Date(endDate);
      let diffMs = (end - init);
      let diffMins = Math.floor((diffMs / 1000) / 60);
      this.intervalslist = [];
      if (tab == '30m') {
        for (i = 0; i < (diffMins / 30); i++) {
          let start = this.intervalslist && this.intervalslist.length == 0 ? new Date(init) : this.intervalslist[this.intervalslist.length - 1].endDate;
          this.setintervallist(new Date(start), new Date(start.getTime() + 30 * 60000), i, (i) * 30 + "-" + (i + 1) * 30);
        }
      }
      else if (tab == '60m') {
        for (i = 0; i < (diffMins / 60); i++) {
          let start = this.intervalslist && this.intervalslist.length == 0 ? new Date(init) : this.intervalslist[this.intervalslist.length - 1].endDate;
          this.setintervallist(new Date(start), new Date(start.getTime() + 60 * 60000), i, (i) * 60 + "-" + (i + 1) * 60);
        }
      }
      else if (tab == 'Last 2hrs') {
        for (i = 0; i < (diffMins / 120); i++) {
          let start = this.intervalslist && this.intervalslist.length == 0 ? new Date(init) : this.intervalslist[this.intervalslist.length - 1].endDate;
          this.setintervallist(new Date(start), new Date(start.getTime() + 120 * 60000), i, (i) * 120 + "-" + (i + 1) * 120);
        }
      }
      else if (tab == 'Last 4hrs') {
        for (i = 0; i < (diffMins / 240); i++) {
          let start = this.intervalslist && this.intervalslist.length == 0 ? new Date(init) : this.intervalslist[this.intervalslist.length - 1].endDate;
          this.setintervallist(new Date(start), new Date(start.getTime() + 240 * 60000), i, (i) * 240 + "-" + (i + 1) * 240);
        }
      }
    }
  }

  getData(items, iteme) {
    let res = this.tdata.filter(res => {
      return (new Date(res.timestamp) >= items) && (new Date(res.timestamp) <= iteme)
    });
    return res;
  }

  setintervallist(startDate, endDate, i, label) {
    let start = startDate;
    let data = this.getData(startDate, endDate);
    if (data && data.length > 0) {
      let getValue: number = Number(data[0].energyActiveImportRegister.split(" ")[0]) - Number(data[data.length - 1].energyActiveImportRegister.split(" ")[0]);
      let battery: number = 0;
      let power: number = 0;
      let currimport: number = 0;
      let curroffered: number = 0;
      let temparature: number = 0;
      let voltage: number = 0;
      for (let j = 0; j < data.length; j++) {
        battery += data[j].soc.split(" ").length > 0 ? (Number.isNaN(Number(data[j].soc.split(" ")[0]))) ? 0 : Number(data[j].soc.split(" ")[0]) : 0;
        power += data[j].powerOffered.split(" ").length > 0 ? (Number.isNaN(Number(data[j].powerOffered.split(" ")[0]))) ? 0 : Number(data[j].powerOffered.split(" ")[0]) : 0;
        currimport += data[j].currentImport.split(" ").length > 0 ? (Number.isNaN(Number(data[j].currentImport.split(" ")[0]))) ? 0 : Number(data[j].currentImport.split(" ")[0]) : 0;
        curroffered += data[j].currentOffered.split(" ").length > 0 ? (Number.isNaN(Number(data[j].currentOffered.split(" ")[0]))) ? 0 : Number(data[j].currentOffered.split(" ")[0]) : 0;
        temparature += data[j].temperature.split(" ").length > 0 ? (Number.isNaN(Number(data[j].temperature.split(" ")[0]))) ? 0 : Number(data[j].temperature.split(" ")[0]) : 0;
        voltage += data[j].voltage.split(" ").length > 0 ? (Number.isNaN(Number(data[j].voltage.split(" ")[0]))) ? 0 : Number(data[j].voltage.split(" ")[0]) : 0;
      }
      battery = battery / data.length;
      power = power / data.length;
      currimport = currimport / data.length;
      curroffered = curroffered / data.length;
      temparature = temparature / data.length;
      voltage = voltage / data.length;
      this.intervalslist.push({ index: i, label: label, startDate: startDate, endDate: endDate, tdata: data, totalMeterValue: getValue.toFixed(2), totalPercentage: battery.toFixed(2), power: power.toFixed(2), currimport: currimport.toFixed(2), curroffered: curroffered.toFixed(2), temparature: temparature.toFixed(2), voltage: voltage.toFixed(2) })
    }
  }

  change(event) {
    if (!!event.startDate && !!event.endDate) {
      this.startDate = event.startDate.$d;
      this.endDate = event.endDate.$d;
    }
  }

  getChargingDuration(start, end) {
    let dateIn: Date = new Date(start);
    let dateOut: Date = new Date(end);
    let result = Math.round((dateOut.getTime() - dateIn.getTime()) / 60000);
    return result
  }

  getDeviceTrans(fromDate, toDate, value, searchFilter,) {
    this.stationService.getDeviceTransaction(this.stationId, value.currentPage + 1, value.pageSize, this.sortColumn, this.sortDirection, searchFilter, fromDate, toDate).subscribe(
      (resp: any) => {
        this.data = resp.data;
        this.totalDataCount = resp.totalItems;
        this.setTransactionMap(this.data)
      },
      error => {
        this.toasterService.error(this.translate.instant('responseFailed'));
      }
    )
  }

  getTransDetails(value, searchFilter) {
    this.stationService.getTransactionData(this.transactionID, this.startDate, this.endDate, this.selectedTab, value.currentPage + 1, value.pageSize, this.sortColumn, this.sortDirection, searchFilter).subscribe(
      (data: any) => {
        this.tdata = data.data;
        this.tTotalDataCount = data.totalItems;
        if (this.tdata.length > 0) {
          const chargingStartTimestampString = this.tdata[0].timestamp;
          const chargingStartTimestamp = new Date(chargingStartTimestampString).getTime();
          const timeDifferenceInSeconds = Math.floor((Date.now() - chargingStartTimestamp) / 1000);
          const countdownDurationInSeconds = 600;
          const timeUntilDisplayInSeconds = Math.max(countdownDurationInSeconds - timeDifferenceInSeconds, 0);
          const initialCountdown = Math.max(timeUntilDisplayInSeconds, 0);
          this.clock = initialCountdown;
          const countdownFunction = () => {
            if (this.clock > 0) {
              --this.clock;
            }
            if (this.clock === 0) {
              this.timeflag = true;
              this.actionFeatureFlag = (this.timeflag && this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.UPDATE) && this.checkStatus);
            } else {
              setTimeout(countdownFunction, this.tick);
            }
          };
          setTimeout(countdownFunction, this.tick);
        }
        this.tdata.map((item: any, i: number) => {
          let empty = 'NA';
          item.id = i;
          item.timestamp = !item.timestamp ? empty : this.authenticationService.convert24HrTo12Hr(this.authenticationService.convertToLocalTime(item.timestamp, this.userInfoService.userDetails.prefCountry), true);
          item.soc = !item.soc || item.soc.toString().toLowerCase() == '0 percent' ? empty : item.soc;
          item.powerOffered = !item.powerActiveImport ? empty : item.powerActiveImport;
          item.currentImport = !item.currentImport ? empty : item.currentImport;
          item.currentOffered = !item.currentOffered ? empty : item.currentOffered;
          item.temperature = !item.temperature ? empty : item.temperature;
          item.voltage = !item.voltage ? empty : item.voltage;
          item.energyActiveImportRegister = !item.energyActiveImportRegister ? empty : this.toKWH(item.energyActiveImportRegister);
        });
        this.initialTransDetailData = this.tdata;
      }, err => {
        this.toasterService.error(this.translate.instant('responseFailed'));
      }
    )
  }

  toKWH(result) {
    let tempArray = result.split(" ")
    return tempArray[0] / 1000;
  }

  actionClick(event) {
    !!event && event == 'deviceTrans' ? this.deviceDataReload() : this.rerenderID(this.pageList, '');
  }

  actionCSV(event) {
    !!event && event == 'deviceTrans' ? this.exportDeviceTrans() : this.exportTransDetails();
  }

  exportDeviceTrans() {
    const options = {
      filename: this.translate.instant('stationDetail.transTitle'),
      showTitle: false,
      title: this.translate.instant('stationDetail.transTitle'),
      useKeysAsHeaders: true,
    }
    this.stationService.getDeviceTransaction(this.stationId, 1, this.totalDataCount, 'transactionId', 'asc', '', this.stDate, this.edDate).subscribe(
      (resp: any) => {
        this.initialTransData = resp.data;
        this.setTransactionMap(this.initialTransData);
        this.exportCSVService.exportCSV(options, this.initialTransData);
      }
    )
  }

  accordionactionCSV(event, item) {
    this.exportTransDetails(item);
  }

  exportTransDetails(item?) {
    const options = {
      filename: this.translate.instant('stationDetail.transactiondetails.transDetails'),
      showTitle: false,
      title: this.translate.instant('stationDetail.transactiondetails.transDetails'),
      useKeysAsHeaders: true,
    }
    item ? this.exportCSVService.exportCSV(options, item.tdata) : this.exportCSVService.exportCSV(options, this.initialTransDetailData);

  }

  linkClick(event: any, selectedTab: any) {
    if (event.column.columnDef == "transactionId") {
      this.actionFeatureFlag = false;
      this.transactionID = event.row.transactionId;
      this.currentStatus = event.row.status;
      this.checkStatus = (this.currentStatus.toLowerCase() === 'charging' || this.currentStatus.toLowerCase() === 'initiated') ? true : false;
      this.selectedTab = selectedTab;
      this.rerenderID(this.pageList, '');
      this.selectedIndex = 4;
      $('#transactionmodel').modal('show');
    }
  }

  loadData(value: any) {
    let val = {
      currentPage: value.currentPage,
      pageSize: value.pageSize
    }
    this.pageList.pageSize = value.pageSize;
    this.rerender(this.stDate, this.edDate, val, '')
  }

  loadDataID(value: any) {
    let val = {
      currentPage: value.currentPage,
      pageSize: value.pageSize
    }
    this.pageList.pageSize = value.pageSize;
    this.rerenderID(val, '')
  }

  sortClick(event: any) {
    this.sortColumn = event.active;
    this.sortDirection = event.direction;
    this.rerender(this.stDate, this.edDate, this.pageList, '');
  }

  sortClickID(event: any) {
    this.sortColumn = event.active;
    this.sortDirection = event.direction;
    this.rerenderID(this.pageList, '');
  }

  rerender(fromdate, todate, value: any, searchFilter?: string) {
    this.getDeviceTrans(fromdate, todate, value, searchFilter);
  }

  deviceDataReload() {
    this.reportFilterApply('')
  }

  rerenderID(value: any, searchFilter?: string) {
    this.getTransDetails(value, searchFilter)
  }

  setTransactionMap(data) {
    data.map((item: any, i: number) => {
      let empty = 'NA';
      item.chargingDuration = (!item.createdDate || !item.stopDate) ? empty : this.getChargingDuration(item.createdDate, item.stopDate)
      item.transactionId = !item.transactionId ? empty : item.transactionId;
      item.connectorId = !item.connectorId ? empty : item.connectorId;
      item.userId = !item.userId ? empty : item.userId;
      item.createdDate = !item.createdDate ? empty : this.authenticationService.convert24HrTo12Hr(this.authenticationService.convertToLocalTime(item.createdDate, this.userInfoService.userDetails.prefCountry));
      item.stopDate = !item.stopDate ? empty : this.authenticationService.convert24HrTo12Hr(this.authenticationService.convertToLocalTime(item.stopDate, this.userInfoService.userDetails.prefCountry));
      item.totalMeterValue = !item.totalMeterValue ? 0 : (item.totalMeterValue) / 1000;
      item.platform = !item.platform ? empty : item.platform
      item.status = !item.status ? empty : item.status;
      item.updatedDate = !item.updatedDate ? empty : this.authenticationService.convert24HrTo12Hr(this.authenticationService.convertToLocalTime(item.updatedDate, this.userInfoService.userDetails.prefCountry));
    });
  }

  checkPermission(id: number, permission: string): boolean {
    return this.userInfoService.filterPermission(id, permission);
  }

  actionFeature(event) {
    let dialogRef = this.dialog.open(GeneralDialogComponent, {
      width: '50vw',
      height: '200px',
      data: { component: ConfirmDialogComponent, button: this.translate.instant('faq.confirmButton'), title: this.translate.instant('stationDetail.deviceTransaction.title'), otherbtn: this.translate.instant('faq.confirmNo'), message: this.translate.instant('stationDetail.deviceTransaction.stopmssg') }
    }).afterClosed().subscribe(res => {
      if (res && res == 'Yes') {
        this.subscription.add(this.stationService.forceStop(this.transactionID).subscribe(r => {
          if (r) {
            this.toasterService.success(this.translate.instant('stationDetail.deviceTransaction.stopped'));
          }
          else {
            this.toasterService.error(this.translate.instant('responseFailed'));
          }
        }));
      }
    }, err => {
      this.toasterService.error(err.message);
    }
    );
  }

  reportFilterApply(event) {
    if (event == '') {
      this.isReloadDevice = true
      this.stDate = '';
      this.edDate = '';
      this.rerender(this.stDate, this.edDate, this.pageList, '')
    }
    else {
      this.stDate = this.authenticationService.convertToLocalTimeForPayload(event.startDate, this.userInfoService.userDetails.prefCountry);
      this.edDate = this.authenticationService.convertToLocalTimeForPayload(event.endDate, this.userInfoService.userDetails.prefCountry);
      this.rerender(this.stDate, this.edDate, this.pageList, '')
    }
  }
}
